import { useState, useEffect } from 'react';
import Image from 'next/image';
import { SnackBarProps } from './types';
import { SnackBarWrapper, Wrapper, Icon, MessageText } from './styles';
import { getImageBasePath } from 'utils/generics';

const SnackBar: React.FC<SnackBarProps> = ({
    message,
    type,
    handleSnakbarComplete,
}) => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (message) {
            setShow(!!message);
        }
    }, [message]);

    useEffect(() => {
        if (message) {
            setTimeout(() => {
                setShow(false);
                handleSnakbarComplete && handleSnakbarComplete();
            }, 3000);
        }
    }, [message]);

    const getColor = () => {
        switch (type) {
            case 'success':
                return '#37C87E';
            case 'failure':
                return '#343758';
            default:
                return '#37C87E';
        }
    };

    return (
        <div
            style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
            }}
        >
            {show && (
                <SnackBarWrapper backgroundColor={getColor()}>
                    <Wrapper>
                        <div>
                            <Icon>
                                <Image
                                    src={getImageBasePath(
                                        type === 'success'
                                            ? '/icons/greenTick.svg'
                                            : '/icons/error.svg'
                                    )}
                                    width={'16px'}
                                    height={'16px'}
                                />
                            </Icon>
                        </div>
                        <MessageText>{message}</MessageText>
                    </Wrapper>
                </SnackBarWrapper>
            )}
        </div>
    );
};

export default SnackBar;
